import DataQualityRoutes from './DataQualityRoutes';

export const DATAQUALITY_BASE_ROUTES = '/dataquality';

export { DataQualityRoutes };
